import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportDefinitionComponentModel} from '../reportDefinitionComponent.model';
import {Injectable} from '@angular/core';
import {
    ReportComponentSummaryConverter
} from '../../../../report-component/api/entity/converter/reportComponentSummary.converter';

@Injectable()
export class ReportDefinitionComponentConverter extends HttpModelConverter<ReportDefinitionComponentModel> {

    constructor(private reportComponentConverter: ReportComponentSummaryConverter) {
        super();
    }
    protected createInstance(): ReportDefinitionComponentModel {
        return new ReportDefinitionComponentModel();
    }

    protected enrichObject(result: ReportDefinitionComponentModel, src: ReportDefinitionComponentModel) {
        result.reportComponent = this.reportComponentConverter.convert(src.reportComponent);
    }
}

